import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import Util from 'root/module/util';
import View from 'view/base';
import View_Feedback_Preview from 'view/portal/feedback_preview';

export default View.extend({
    className: 'portal-roadmap-column',

    is_loaded: false, // finished initial loading?

    load_page: 0,
    load_page_size: 20,
    is_all_loaded: false,

    sort_by: 'date', // date, vote, trending
    categories: [],
    search: '',

    views: {
        feedback_preview: {}
    },

    events: {
        'click .reload': 'onReload'
    },

    dom_handlers: {
        onWindowResize: function(e) {
            this.setScrollerSize();
        },

        onReload: function() {
            this.reload();
        }
    },

    event_handlers: {
        onFeedbackAdd: function(model) {
            var workflow_ids = this.getWorkflowIds();

            if (workflow_ids.indexOf(model.get('workflow')) === -1) {
                return;
            }

            var view = this.createFeedbackView(model);
            view.render().$el.appendTo(this.$el.find('.region-feedback'));

            this.setScrollerSize();
        },

        onFeedbackRemove: function(model) {
            if (typeof this.views.feedback_preview['_' + model.id] !== 'undefined') {
                this.views.feedback_preview['_' + model.id].remove();
                delete this.views.feedback_preview['_' + model.id];

                this.setScrollerSize();
            }
        },

        onFeedbackWorkflowChange: function(model) {
            var workflow_ids = this.getWorkflowIds();

            if (workflow_ids.indexOf(model.get('workflow')) === -1) {
                if (typeof this.views.feedback_preview['_' + model.id] !== 'undefined') {
                    // feedback moved away
                    Cache.feedback.remove(model);
                }
            } else {
                if (typeof this.views.feedback_preview['_' + model.id] === 'undefined') {
                    // feedback moved in
                    //Cache.feedback.add(model);
                }
            }
        }
    },

    initialize: function(options) {
        this.sort_by    = options.sort_by;
        this.categories = options.categories;
        this.search     = options.search;

        this.views = {
            feedback_preview: {}
        };

        var workflow_ids = this.getWorkflowIds();

        Cache.feedback.where({workflow: this.model.id}).forEach(function(model) {
            if (workflow_ids.indexOf(model.get('workflow')) !== -1) {
                this.createFeedbackView(model);
            }
        }.bind(this));

        this.listenTo(Cache.feedback, 'add',    this.event_handlers.onFeedbackAdd);
        this.listenTo(Cache.feedback, 'remove', this.event_handlers.onFeedbackRemove);

        this.listenTo(Cache.feedback, 'change:workflow', this.event_handlers.onFeedbackWorkflowChange);

        $(window).on('resize.' + this.cid, this.dom_handlers.onWindowResize.bind(this));
        this.on('remove', function() {
            $(window).off('resize.' + this.cid);
        });
    },

    getWorkflowIds: function() {
        var workflow_ids = [];

        Cache.workflow.where({portal_status_id: this.model.id}).forEach(function(model) {
            workflow_ids.push(model.id);
        });

        return workflow_ids;
    },

    createFeedbackView: function(model) {
        this.views.feedback_preview['_' + model.id] = new View_Feedback_Preview({
            model: model,
            mode: 'roadmap'
        });

        return this.views.feedback_preview['_' + model.id];
    },

    reload: function() {
        this.load_page = 0;
        this.loadFeedback();
    },

    reset: function(options) {
        if (options) {
            this.sort_by    = options.sort_by;
            this.categories = options.categories;
            this.search     = options.search;
        }

        this.load_page     = 0;
        this.is_all_loaded = false;

        _.each(this.views.feedback_preview, function(view) {
            view.remove();
        });
        this.views.feedback_preview = {};

        this.loadFeedback();
    },

    loadFeedback: function() {
        this.load_page++;

        this.xhr = Cache.app.request({
            action: 'portal/loadFeedback',
            context: this,
            data: {
                page         : this.load_page,
                page_size    : this.load_page_size,
                status_ids   : [this.model.id],
                sort_by      : this.sort_by,
                search       : this.search,
                categories   : this.categories
            },
            success: function(response) {
                this.$el.find('.init-placeholder').remove();

                Cache.feedback_comment.add(response.feedback_comment);
                Cache.feedback_screenshot.add(response.feedback_screenshot);
                Cache.feedback.add(response.feedback);

                if (response.feedback.length < this.load_page_size) {
                    this.is_all_loaded = true;
                }

                if (typeof response.count !== 'undefined') {
                    this.$el.find('.region-title .count').text(response.count);
                }

                this.setScrollerSize();
            },
            complete: function() {
                this.trigger('loadFinish', this.model);

                this.xhr = null;
                this.$el.find('.region-feedback').removeClass('loadmore');
            }
        });
    },

    setScrollerSize: function() {
        var scroll_top    = this.$el.find('.region-feedback').scrollTop();
        var inner_height  = this.$el.find('.region-feedback').innerHeight();
        var scroll_height = this.$el.find('.region-feedback').get(0).scrollHeight;

        if (inner_height < scroll_height && Math.ceil(scroll_top + inner_height) < scroll_height) {
            this.$el.find('.region-main').addClass('has-scroll-bottom');
        } else {
            this.$el.find('.region-main').removeClass('has-scroll-bottom');

            if (this.xhr || this.is_all_loaded) {
                return;
            }

            this.$el.find('.region-feedback').addClass('loadmore');

            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.loadFeedback();
            }, 1000);
        }

        this.$el.find('.region-main').toggleClass('has-scroll-top', scroll_top > 0);
    },

    hide: function() {
        this.$el.hide();
    },

    show: function() {
        this.$el.show();
    },

    onRender: function() {
        this.$el.find('.region-feedback').on('scroll', this.setScrollerSize.bind(this));
    },

    render: function() {
        var uid = 'c_' + _.uniqueId();

        var placeholder =
        '<div class="loader-placeholder-regular margin-bottom-16 float-left" style="width:32px;height:32px;"></div>' +
        '<div class="margin-left-40">' +
            '<div class="loader-placeholder margin-bottom-8"></div>' +
            '<div class="loader-placeholder margin-bottom-8"></div>' +
            '<div class="loader-placeholder margin-bottom-8" style="width:80px;"></div>' +
        '</div>';

        var content =
        '<div class="region-title">' +
            '<span class="name">' + this.model.escape('status_name') + '</span>' +
            '<span class="count"></span>' +
        '</div>' +
        '<div class="region-main">' +
            '<div class="scroller-top"></div>' +
            '<div class="scroller-bottom"></div>' +
            '<div class="region-feedback">' +
                '<div class="init-placeholder">' +
                    placeholder +
                    '<div class="divider-24"></div>' +
                    placeholder +
                    '<div class="divider-24"></div>' +
                    placeholder +
                '</div>' +
            '</div>' +
        '</div>' +
        '<style>' +
        '.portal-roadmap-column[data-id="' + uid + '"] {' +
            '--column-colour: ' + this.model.get('colour') + ';' +
            '--column-colour-bg: ' + Util.hexToRgba(this.model.get('colour'), 0.02) + ';' +
        '}' +
        '</style>';

        this.$el.html(content);
        this.$el.attr('data-id', uid);

        this.loadFeedback();

        this.onRender();

        return this;
    }
});